"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newDelegateProxy = void 0;
/**
 * Creates a new combined object with keys in `overrides` taking precedence, and then
 * any other keys falling back to `delegate`.
 */
function newDelegateProxy(delegate, overrides) {
    function pickTarget(key) {
        return Reflect.has(overrides, key) ? overrides : delegate;
    }
    return new Proxy(delegate, {
        get(object, key) {
            return Reflect.get(pickTarget(key), key);
        },
        set(object, key, value) {
            return Reflect.set(pickTarget(key), key, value);
        },
    });
}
exports.newDelegateProxy = newDelegateProxy;
